/* eslint-disable no-extra-boolean-cast */
// import React, { useEffect } from 'react';
// import { useAppDispatch, useAppSelector } from '@store/hooks';
// import { useFormik } from 'formik';
// import { useTranslation } from 'react-i18next';
// import CustomAlert from '@components/Shared/Alert/CustomAlert';
// import { Form } from 'react-bootstrap';
// import Select from 'react-select';
// import useGetAccounts from '@hooks/Finance/ChartAccountsDetails/useGetAccounts';
// import { AddBankAccountsSchema, AddCashBoxesSchema } from '../../../ValidationForm/validationSchema';
// import {
//   getApBankAccountsList,
//   getApBankAccountsById,
//   updateApBankAccounts
// } from '@store/Finance/AP/ApBankAccounts/ApBankAccountsSlice';
// import Loading from '@components/Shared/Loader/Loading';

// interface props {
//   ID?: string;
// }

// const Update: React.FC<props> = ({ ID }) => {
//   const { i18n, t } = useTranslation();
//   const dispatch = useAppDispatch();
//   const { OptionsAccounts, loading, error } = useGetAccounts();

//   useEffect(() => {
//     if (ID) {
//       dispatch(getApBankAccountsById(ID));
//     }
//   }, [ID, dispatch]);
//   const { ApBankAccountsById: data, loading: loading2, error: error2 } = useAppSelector(a => a.ApBankAccounts);

//   const formik = useFormik({
//     initialValues: {
//       ntxBankId: data.ntxBankId ?? '',
//       name: data.name ?? '',
//       name2: data.name2 ?? '',
//       description: data.description ?? '',
//       bankAccount: data.bankAccount ?? '',
//       accountId: data.accountId ?? '',
//       accountReconcileId: data.accountReconcileId ?? '',
//       iban: data.iban ?? ''
//     },
//     enableReinitialize: true,
//     validationSchema: AddCashBoxesSchema(t),
//     onSubmit: values => {
//       dispatch(
//         updateApBankAccounts({
//           id: data.id,
//           name: values.name,
//           name2: values.name2,
//           ntxBankId: values.ntxBankId,
//           bankAccount: values.bankAccount,
//           iban: values.iban,
//           description: values.description,

//           accountId: values.accountId,
//           accountReconcileId: values.accountReconcileId
//         })
//       )
//         .unwrap()
//         .then((res: any) => {
//           if (res?.succeeded === true) {
//             CustomAlert({ action: 'Edit' });
//             document.getElementById('closeModalForm')?.click();
//             dispatch(getApBankAccountsList());
//             formik.resetForm();
//           } else {
//             CustomAlert({ action: 'Error', msg: res?.message });
//           }
//         })
//         .catch((error: any) => {
//           CustomAlert({ action: 'Error' });
//         })
//         .finally(() => {
//           formik.setSubmitting(false);
//         });
//     }
//   });
//   const { values, errors, touched } = formik;

//   return (
//     <Loading loading={loading || loading2} error={error || error2}>
//       <Form onSubmit={formik.handleSubmit}>
//         <div className='row'>
//           <div className='col-xl-6'>
//             <div className='form-group mb-3'>
//               <label className='form-label'>{t('LocalName')}</label>
//               <Form.Control
//                 className='form-control  '
//                 type='text'
//                 autoComplete='off'
//                 name='name2'
//                 onChange={formik.handleChange}
//                 value={formik.values.name2}
//                 isInvalid={!!(formik.touched.name2 && formik.errors.name2)}
//               />
//               <div className='text-danger small'>{touched.name2 && errors.name2}</div>
//             </div>
//           </div>
//           <div className='col-xl-6'>
//             <div className='form-group mb-3'>
//               <label className='form-label'>{t('GlobalName')}</label>
//               <Form.Control
//                 className='form-control  '
//                 type='text'
//                 autoComplete='off'
//                 name='name'
//                 onChange={formik.handleChange}
//                 value={formik.values.name}
//                 isInvalid={!!(formik.touched.name && formik.errors.name)}
//               />
//               <div className='text-danger small'>{touched.name && errors.name}</div>
//             </div>
//           </div>

//           <div className='col-xl-6 '>
//             <div className='form-group mb-3'>
//               <label className='form-label'>{t('Accounts')}</label>
//               <Select
//                 classNamePrefix='react-select'
//                 className={`w-100 ${
//                   formik.touched.accountId && formik.errors.accountId ? 'border border-danger' : ''
//                 } `}
//                 isLoading={loading}
//                 isSearchable={true}
//                 isClearable
//                 name='accountId'
//                 options={OptionsAccounts}
//                 placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
//                 onChange={(option: any) => {
//                   formik.setFieldValue('accountId', option === null ? null : option.value);
//                 }}
//                 value={OptionsAccounts?.find(f => f.value === formik.values.accountId)}
//               />
//               <div className='text-danger small'>{touched.accountId && errors.accountId}</div>
//             </div>
//           </div>

//           <div className='col-xl-6 '>
//             <div className='form-group mb-3'>
//               <label className='form-label'>{t('حساب التسوية')}</label>
//               <Select
//                 classNamePrefix='react-select'
//                 className={`w-100 ${
//                   formik.touched.accountId && formik.errors.accountId ? 'border border-danger' : ''
//                 } `}
//                 isLoading={loading}
//                 isSearchable={true}
//                 isClearable
//                 name='accountReconcileId'
//                 options={OptionsAccounts}
//                 placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
//                 onChange={(option: any) => {
//                   formik.setFieldValue('accountReconcileId', option === null ? null : option.value);
//                 }}
//                 value={OptionsAccounts?.find(f => f.value === formik.values.accountReconcileId)}
//               />
//               <div className='text-danger small'>{touched.accountReconcileId && errors.accountReconcileId}</div>
//             </div>
//           </div>
//         </div>

//         <div className='text-center mt-2'>
//           <div className='d-flex justify-content-between gap-2'>
//             <button disabled={formik.isSubmitting} type='submit' className='btn btn-lg btn-theme mb-1 w-100 rounded-0'>
//               {formik.isSubmitting ? (
//                 <div className='spinner-border spinner-border-sm me-2'></div>
//               ) : (
//                 <i className='fas fa-lg fa-fw me-2 fa fa-save'></i>
//               )}
//               {t('Save')}
//             </button>
//             <button
//               type='button'
//               className='btn btn-lg  btn-default mb-1 w-100 rounded-0'
//               data-bs-dismiss='modal'
//               id='closeModalForm'
//             >
//               <i className='fa fa-power-off fa-fw me-1'></i> {t('Cancel')}
//             </button>
//           </div>
//         </div>
//       </Form>
//     </Loading>
//   );
// };

// export default Update;


import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { useFormik } from 'formik';
import { useTranslation } from 'react-i18next';
import CustomAlert from '@components/Shared/Alert/CustomAlert';
import { Form } from 'react-bootstrap';
import Select from 'react-select';
import useGetAccounts from '@hooks/Finance/ChartAccountsDetails/useGetAccounts';
import { AddCashBoxesSchema } from '../../../ValidationForm/validationSchema';
import {
  getApBankAccountsList,
  getApBankAccountsById,
  updateApBankAccounts
} from '@store/Finance/AP/ApBankAccounts/ApBankAccountsSlice';
import Loading from '@components/Shared/Loader/Loading';
import useGetOperatingUnitWithPermission from '@hooks/NTX/Organization/useGetOperatingUnitWithPermission';

interface props {
  ID?: string;
}

const Update: React.FC<props> = ({ ID }) => {
  const { i18n, t } = useTranslation();
  const dispatch = useAppDispatch();

  const { OptionsAccounts, loading, error } = useGetAccounts();
  const { OperatingUnitOptions, loading: loading1, error: error1 } = useGetOperatingUnitWithPermission();

  useEffect(() => {
    if (ID) dispatch(getApBankAccountsById(ID));
  }, [ID, dispatch]);

  const { ApBankAccountsById: data, loading: loading2, error: error2 } = useAppSelector(a => a.ApBankAccounts);

  const formik = useFormik({
    initialValues: {
      ntxBankId: data.ntxBankId ?? '',
      name: data.name ?? '',
      name2: data.name2 ?? '',
      description: data.description ?? '',
      bankAccount: data.bankAccount ?? '',
      accountId: data.accountId ?? null,
      accountReconcileId: data.accountReconcileId ?? null,
      iban: data.iban ?? '',
      organizationId: (data as any)?.organizationId ?? null // ✅ الجديد
    },
    enableReinitialize: true,
    validationSchema: AddCashBoxesSchema(t),
    onSubmit: values => {
      dispatch(
        updateApBankAccounts({
          id: data.id,
          name: values.name,
          name2: values.name2,
          ntxBankId: values.ntxBankId,
          bankAccount: values.bankAccount,
          iban: values.iban,
          description: values.description,
          accountId: values.accountId,
          accountReconcileId: values.accountReconcileId,
          organizationId: values.organizationId // ✅ الجديد
        })
      )
        .unwrap()
        .then((res: any) => {
          if (res?.succeeded === true) {
            CustomAlert({ action: 'Edit' });
            document.getElementById('closeModalForm')?.click();
            dispatch(getApBankAccountsList());
            formik.resetForm();
          } else {
            CustomAlert({ action: 'Error', msg: res?.message });
          }
        })
        .catch(() => {
          CustomAlert({ action: 'Error' });
        })
        .finally(() => {
          formik.setSubmitting(false);
        });
    }
  });

  const { values, errors, touched } = formik;

  return (
    <Loading loading={loading || loading1 || loading2} error={error || error1 || error2}>
      <Form onSubmit={formik.handleSubmit}>
        <div className='row'>
    

          <div className='col-xl-6'>
            <div className='form-group mb-3'>
              <label className='form-label'>{t('LocalName')}</label>
              <Form.Control
                className='form-control'
                type='text'
                autoComplete='off'
                name='name2'
                onChange={formik.handleChange}
                value={values.name2}
                isInvalid={!!(touched.name2 && errors.name2)}
              />
              <div className='text-danger small'>{touched.name2 && (errors.name2 as any)}</div>
            </div>
          </div>

          <div className='col-xl-6'>
            <div className='form-group mb-3'>
              <label className='form-label'>{t('GlobalName')}</label>
              <Form.Control
                className='form-control'
                type='text'
                autoComplete='off'
                name='name'
                onChange={formik.handleChange}
                value={values.name}
                isInvalid={!!(touched.name && errors.name)}
              />
              <div className='text-danger small'>{touched.name && (errors.name as any)}</div>
            </div>
          </div>
                {/* ✅ Operating Unit */}
          <div className='col-xl-6'>
            <div className='form-group mb-3'>
              <label className='form-label'>{t('OperatingUnit') || 'Operating Unit'}</label>
              <Select
                classNamePrefix='react-select'
                className={`w-100 ${
                  !!(touched.organizationId && errors.organizationId)  ? 'border border-danger' : ''
                }`}
                isLoading={loading1}
                isSearchable
                isClearable
                name='organizationId'
                options={OperatingUnitOptions}
                placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                onChange={(option: any) => {
                  formik.setFieldValue('organizationId', option ? option.value : null);
                }}
                value={OperatingUnitOptions?.find((f: any) => f.value === values.organizationId) ?? null}
              />
              <div className='text-danger small'>{touched.organizationId && (errors.organizationId as any)}</div>
            </div>
          </div>

          <div className='col-xl-6'>
            <div className='form-group mb-3'>
              <label className='form-label'>{t('Accounts')}</label>
              <Select
                classNamePrefix='react-select'
                className={`w-100 ${!!(touched.accountId && errors.accountId) ? 'border border-danger' : ''}`}
                isLoading={loading}
                isSearchable
                isClearable
                name='accountId'
                options={OptionsAccounts}
                placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                onChange={(option: any) => {
                  formik.setFieldValue('accountId', option ? option.value : null);
                }}
                value={OptionsAccounts?.find(f => f.value === values.accountId) ?? null}
              />
              <div className='text-danger small'>{touched.accountId && (errors.accountId as any)}</div>
            </div>
          </div>

          <div className='col-xl-6'>
            <div className='form-group mb-3'>
              <label className='form-label'>{t('حساب التسوية')}</label>
              <Select
                classNamePrefix='react-select'
                className={`w-100 ${
                  !!(touched.accountReconcileId && errors.accountReconcileId) ? 'border border-danger' : ''
                }`}
                isLoading={loading}
                isSearchable
                isClearable
                name='accountReconcileId'
                options={OptionsAccounts}
                placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                onChange={(option: any) => {
                  formik.setFieldValue('accountReconcileId', option ? option.value : null);
                }}
                value={OptionsAccounts?.find(f => f.value === values.accountReconcileId) ?? null}
              />
              <div className='text-danger small'>
                {touched.accountReconcileId && (errors.accountReconcileId as any)}
              </div>
            </div>
          </div>
        </div>

        <div className='text-center mt-2'>
          <div className='d-flex justify-content-between gap-2'>
            <button disabled={formik.isSubmitting} type='submit' className='btn btn-lg btn-theme mb-1 w-100 rounded-0'>
              {formik.isSubmitting ? (
                <div className='spinner-border spinner-border-sm me-2'></div>
              ) : (
                <i className='fas fa-lg fa-fw me-2 fa fa-save'></i>
              )}
              {t('Save')}
            </button>

            <button
              type='button'
              className='btn btn-lg btn-default mb-1 w-100 rounded-0'
              data-bs-dismiss='modal'
              id='closeModalForm'
            >
              <i className='fa fa-power-off fa-fw me-1'></i> {t('Cancel')}
            </button>
          </div>
        </div>
      </Form>
    </Loading>
  );
};

export default Update;
